var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        _vm.$.plan_item,
        _vm.planData.name,
        _vm.isPopup ? _vm.$.popup_item : _vm.$.page_item,
        _vm.isAnnual ? _vm.$.annual : _vm.$.month,
      ],
    },
    [
      _c("div", { class: _vm.$.title }, [
        _c(
          "div",
          { class: _vm.$.plan_name, style: { textTransform: "capitalize" } },
          [_vm._v("\n      " + _vm._s(_vm.planData.plan_name) + "\n    ")]
        ),
        _vm._v(" "),
        _c("div", { class: _vm.$.title_chips }, [
          !_vm.isAnnual
            ? _c("div", { class: _vm.$.chip }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.locales("plans_annually_locale")) +
                    "\n      "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { class: _vm.$.chip }, [_vm._v("\n        -30%\n      ")]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { class: _vm.$.description }, [
        _vm._v(
          "\n    " +
            _vm._s(
              _vm.locales(_vm.planData.plan_title_locale + "_plan_info_locale")
            ) +
            "\n  "
        ),
      ]),
      _vm._v(" "),
      _c("div", { class: [_vm.$.price, _vm.$.action_box] }, [
        _c("div", { class: _vm.$.panel }, [
          _c("div", { class: _vm.$.usd }, [
            _c("span", { class: _vm.$.usd__currency }, [_vm._v("$")]),
            _c("span", { class: [_vm.$.usd__price, _vm.$.crossed_out] }, [
              _vm._v(_vm._s(_vm.priceValues.price)),
            ]),
            _c("span", { class: _vm.$.usd__price }, [
              _vm._v(_vm._s(_vm.priceValues.discont)),
            ]),
            _c("span", { class: _vm.$.usd__label }, [_vm._v("USD")]),
          ]),
          _vm._v(" "),
          _c("div", { class: _vm.$.description }, [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.isAnnual
                    ? "" + _vm.locales("per_user_billed_annually_locale")
                    : _vm.locales("per_user_locale") +
                        " " +
                        _vm.locales("per_month_key")
                ) +
                "\n      "
            ),
          ]),
        ]),
        _vm._v(" "),
        !_vm.isPopup || _vm.isTrial
          ? _c(
              "div",
              {
                class: [_vm.$.btn, _vm.$.upgrade_btn],
                on: { click: _vm.demoClick },
              },
              [_vm._v("\n      " + _vm._s(_vm.buttonText) + "\n    ")]
            )
          : _vm.isPopup && !_vm.planData.isCurrentPaymentPlan
          ? _c(
              "div",
              {
                class: [_vm.$.btn, _vm.$.upgrade_btn],
                on: { click: _vm.demoClick },
              },
              [_vm._v("\n      " + _vm._s(_vm.buttonText) + "\n    ")]
            )
          : _vm.isPopup && _vm.planData.isCurrentPaymentPlan
          ? _c(
              "div",
              { class: [_vm.$.current_plan_sticker, _vm.planData.name] },
              [
                _c("webix-ui", {
                  class: _vm.$.plan_check_icon,
                  attrs: { config: _vm.icons.check },
                }),
                _vm._v(" "),
                _c("div", { class: _vm.$.sticker_text }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.locales("current_plan")) +
                      "\n      "
                  ),
                ]),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          class: _vm.$.plan_features,
          style: { height: _vm.heights.featuresSection + "px" },
        },
        [
          _c("div", {
            ref: "featuresDesc",
            class: _vm.$.features_desc,
            domProps: {
              innerHTML: _vm._s(_vm.getPlanFeaturesListTitle(_vm.planData)),
            },
          }),
          _vm._v(" "),
          _c("ul", { ref: "featuresList", class: _vm.$.features_list }, [
            _c("li", { class: _vm.$.item }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.locales(_vm.planData.plan_title_locale + "_feature_1")
                  ) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _c("li", { class: _vm.$.item }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.locales(_vm.planData.plan_title_locale + "_feature_2")
                  ) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _c("li", { class: _vm.$.item }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.locales(_vm.planData.plan_title_locale + "_feature_3")
                  ) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _c("li", { class: _vm.$.item }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.locales(_vm.planData.plan_title_locale + "_feature_4")
                  ) +
                  "\n      "
              ),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          class: [_vm.$.about_plan_link, _vm.$.link],
          attrs: {
            href:
              _vm.isPopup === true
                ? _vm.locales(
                    "about_plan_href_" + _vm.planData.plan_title_locale
                  )
                : "#features",
            target: _vm.isPopup === true ? "_blank" : null,
          },
          on: {
            click: function ($event) {
              return _vm.linkClick(_vm.planData.plan_name)
            },
          },
        },
        [
          [
            _vm._v(
              "\n      " + _vm._s(_vm.locales("about_link_compare")) + "\n    "
            ),
          ],
          _vm._v(" "),
          _c(
            "svg",
            {
              attrs: {
                width: "20",
                height: "11",
                viewBox: "0 0 20 11",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M14.25 0.75L18.75 5.25M18.75 5.25L14.25 9.75M18.75 5.25H0.75",
                  stroke: "white",
                  "stroke-width": "1.5",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
            ]
          ),
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { class: _vm.$.bottom_bg }, [
        _c("img", {
          class: _vm.$.img,
          attrs: {
            src: "https://cdn.ganttpro.com/app/imgs/pricing/BF_card_background.png",
          },
        }),
        _vm._v(" "),
        _c("div", { class: _vm.$.bg }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }